export default __webpack_public_path__ + "static/media/talk.51183a86.png";